import React from "react";
import { useDelete } from "../../../api/useCall";
import { useMutateBody } from "../../../api/useQuery";
import type { UserProfil } from "../../../api/useUsers";
import { useUsers } from "../../../api/useUsers";
import useToasts from "@ui/Toast/useToasts";
import t from "../../../i18n";
import ModalForm from "@ui/Modal/Form";

interface P {
  userProfil: UserProfil;
  onRequestClose: () => void;
}

const DeleteUserModalForm = ({ userProfil, onRequestClose }: P) => {
  const { addToast } = useToasts();
  const deleteUser = useDelete("/users/:userId(uuid)");
  const users = useUsers();
  const mutateUsers = useMutateBody("/users");
  const handleSubmit = React.useCallback(async () => {
    const rollbackMutate = mutateUsers(users.filter(u => u.id !== userProfil.id));

    try {
      await deleteUser({
        routeParams: {
          userId: userProfil.id,
        },
      });
      addToast(
        "success",
        t("users.modal.delete.delete_user.toast", { name: userProfil.name ?? userProfil.login }),
      );
    } catch (e) {
      rollbackMutate();
      throw e;
    }

    return true;
  }, [addToast, deleteUser, mutateUsers, userProfil.login, userProfil.name, userProfil.id, users]);

  return (
    <ModalForm
      onSubmit={handleSubmit}
      onRequestClose={onRequestClose}
      focusCancel
      okButtonName={t("modal.delete")}
      okButtonVariant="destructive"
    >
      {t("users.modal.delete.are_you_sure", { login: userProfil.login })}
    </ModalForm>
  );
};

export default React.memo(DeleteUserModalForm);
